import React, { useState, useRef, forwardRef } from 'react'
import Icon, { CheckOutlined, StopOutlined } from '@ant-design/icons'
import DataServices from '../../../Services/DataServices'
import IntlMessages from '../../../util/IntlMessages'
import {
  Table,
  Card,
  Col,
  Row,
  Button,
  Checkbox,
  Collapse,
  Tabs,
  Tag,
  Form,
  AutoComplete,
  Input,
  message,
  Spin
} from 'antd'
import { InputGroup } from 'reactstrap'
import Skeleton from 'react-loading-skeleton'
import { useHistory, useRouteMatch } from 'react-router'
import ds from '../../../Services/DataServices'
import ProductItemRightPanel from './InventoryProductItemRightPanel'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import {
  loadInventoryTakesItemsData,
  loadIsInventoryTakesItemsLoading
} from '../../../appRedux/actions/Inventory'
import { loadSelectedOutlet } from '../../../appRedux/actions/CommonData'
import {
  getDecryptID,
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  getRandomInt,
  checkExpiresSub,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import { INVENTORY_SCREEN } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import ProductSearch from '../../../components/ProductSearch'
import {
  StringIsNullOrEmpty,
  loadSearchSelectedProduct
} from '../../../appRedux/actions'
import CustomScrollbars from '../../../util/CustomScrollbars'
import { findDOMNode } from 'react-dom'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}
const ForwardedTable = forwardRef((props, ref) => {
  return <Table {...props} ref={ref} />
})

const InventoryCountItemDetails = ({ match }) => {
  const Panel = Collapse.Panel
  const inventoryTakeID = match.params.id
  const { TabPane } = Tabs
  const history = useHistory()
  const { path, url } = useRouteMatch()
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const inputRef = useRef(null)

  //#region useState
  const [options, setOptions] = useState([])
  const [getSearchProd, setSearchProd] = useState([])
  const [getselectedRowKeys, setselectedRowKeys] = useState([])
  const [getCurrentSelectedProduct, setCurrentSelectedProduct] = useState({})
  const [getOutletID, setOutletID] = React.useState('')

  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [getShortCurr, setShortCurr] = useState('')
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)
  //#endregion useState

  //#region useSelector
  const getReduxInventoryProductData = useSelector(
    ({ Inventory }) => Inventory.getInventoryProductData
  )
  const getReduxInventoryProductDataLoading = useSelector(
    ({ Inventory }) => Inventory.loader
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getSearchSelectedProduct = useSelector(
    ({ Products }) => Products.searchSelectedProduct
  )
  //#endregion useSelector

  //#region useEffect
  //for selected outlet & register, commmon Data
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!verifyPkgFeature(PkgFeatures.InventoryManagement)) {
        setIsFeatureAllowed(false)
      }
      dispatch(setCommonConfigs(INVENTORY_SCREEN))
      let body = {
        BehaviorName: 1,
        InventoryTakeID: inventoryTakeID
      }
      getInventoryTakesItems(body, PkgFeatures.InventoryManagement)
    }

    return () => (mounted = false)
  }, [])

  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      const commonData = getReduxCommonSetting

      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}

      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
        setShortCurr(currencyData.currencyCode)
        setCurrData(currencyData)
      }

      // rights && permissions

      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)

        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)

          setAccessLoading(false)
        } else {
          toInitialState()

          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getSearchSelectedProduct) {
        onSelect(getSearchSelectedProduct)
      }
    }
    return () => (mounted = false)
  }, [getSearchSelectedProduct])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }

    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }

    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }

    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }

    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }

    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])

    setPermissions([])

    setIsAllowRead(false)

    setIsDisableCreate(true)

    setIsDisableUpdate(true)

    setIsDisableDelete(true)

    setAccessLoading(true)
  }

  //#endregion useEffect

  //#region Api Services
  async function getInventoryTakesItems (body, featureID) {
    //setLoader(true);
    dispatch(loadIsInventoryTakesItemsLoading(true))
    const getInventoryData = ds.getInventoryTakesItems(
      body,
      BEHAVIOUR_TYPE.GET,
      featureID
    )
    await getInventoryData
      .then(response => {
        if (response) {
          let invData =
            response &&
            response.map(e => {
              return {
                key: getRandomInt(100000000),
                InventoryTakeItemID: e.inventoryTakeItemID,
                InventoryTakeID: e.inventoryTakeID,
                ProductID: e.productID,
                OutletID: e.outletID,
                ProductName: e.productName,
                IsCounted: e.isCounted,
                Counted: e.counted,
                Expected: e.expected,
                SKU: e.sku,
                Cost: e.cost,
                InventoryName: e.inventoryName,
                IsChange: false
              }
            })

          //setInventoryProductData(invData);
          //setLoader(false);
          if (invData.length > 0) {
            setOutletID(invData[0].OutletID)
          }
          dispatch(loadInventoryTakesItemsData(invData))
          dispatch(loadIsInventoryTakesItemsLoading(false))
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        dispatch(loadIsInventoryTakesItemsLoading(false))
        if (e.response && e.response.status === 401 && checkExpiresSub() > 0) {
          message.error('Token Expired! Redirecting to Login Page')
          setTimeout(() => {
            dispatch(userLogOut('store.getState()'))
          }, 3000)
        } else {
          message.error('Something Went Wrong...')
        }
      })
  }
  async function postInventoryTakesItems (body, featureID) {
    await ds
      .postInventoryTakesItemsDataService(
        body,
        BEHAVIOUR_TYPE.UPDATE,
        featureID
      )
      .then(res => {
        if (res.data.data.isSaveUdate) {
          dispatch(loadIsInventoryTakesItemsLoading(false))
          message.success('Inventory Count Items Successfully Saved')
          if (body.IsReview && res.data.data.isInvExecSaveUpdate) {
            history.push(
              `/Dashboard/inventory/inventorycount/${res.data.data.inventoryTakeID}/review`
            )
          } else {
            history.push('/Dashboard/inventory/inventorycount/listing')
          }
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        dispatch(loadIsInventoryTakesItemsLoading(false))
        message.error('Something went wrong...')
      })
  }
  //#endregion Api Services

  //#region Change Functions, OnClick Form Save
  const handleInventoryPauseReview = isReview => {
    dispatch(loadIsInventoryTakesItemsLoading(true))
    let inventoryData = [...getReduxInventoryProductData]

    //IsChange means Sirf wohe products save hn jispr koi change hwa hy ,,
    let InventoryProducts =
      inventoryData != undefined &&
      inventoryData &&
      inventoryData.map(e => {
        return {
          ProductID: e.ProductID.toString(),
          Counted: e.Counted.toString(),
          InventoryTakeItemID: e.InventoryTakeItemID.toString(),
          IsCounted: e.IsCounted,
          Expected: e.Expected.toString(), // Isk backend sy bhe verify krna hy
          Cost: e.Cost
        }
      })

    if (inventoryTakeID != '' && InventoryProducts.length > 0) {
      let body = {
        BehaviorName: 3,
        IsReview: isReview,
        InventoryTakeID: inventoryTakeID,
        InventoryProducts: InventoryProducts
      }
      postInventoryTakesItems(body, PkgFeatures.InventoryManagement)
    } else if (isReview) {
      let body = {
        BehaviorName: 3,
        IsReview: isReview,
        InventoryTakeID: inventoryTakeID,
        InventoryProducts: []
      }
      postInventoryTakesItems(body, PkgFeatures.InventoryManagement)
      history.push(
        `/Dashboard/inventory/inventorycount/${inventoryTakeID}/review`
      )
    } else {
      history.push('/Dashboard/inventory/inventorycount/listing')
    }
  }
  const handleClickProductCount = () => {
    let countValue = form.getFieldValue('Quantity')
    if (countValue != '') {
      let inventoryProducts = [...getReduxInventoryProductData]
      let temp = inventoryProducts.filter(
        e => e.key == getCurrentSelectedProduct.key
      )[0]
      let totalCount = parseInt(temp.Counted) + parseInt(countValue)
      temp.Counted = totalCount.toString()
      temp.IsCounted = true
      temp.IsChange = true
      // setInventoryProductData(inventoryProducts);
      dispatch(loadInventoryTakesItemsData(inventoryProducts))
    } else {
      message.error('Please enter product quantity')
    }
    form.setFieldsValue({ Quantity: 1 })
  }
  function getRowColor (record) {
    let className = 'cursor-pointer'
    if (record.Expected == record.Counted) {
      className += ' sequence-equal' // Add a space before "sequence-equal"
    }
    return className
  }

  const handleSearch = async (value, outletID) => {
    if (!outletID) {
      //check to consider later
      outletID =
        getReduxInventoryProductData && getReduxInventoryProductData.length > 0
          ? getReduxInventoryProductData[0].OutletID
          : '1'
    }
    if (value.length > 1) {
      let nameArray = []
      let searchProdPriceBook = {
        data: {
          msgCode: '',
          msgDescription: ''
        }
      }
      await ds
        .getBookSearchProd(
          `?keys=${value}&outletid=${outletID}&isstock=${false}&isinventory=${true}&isactiveproduct=${true}`
        )
        .then(response => (searchProdPriceBook.data = response.data))
        .catch(e => {
          //message.error("Kindly Check Internet Connection...");
          //console.log("handleSearch", e);
        })

      if (searchProdPriceBook.data.msgCode == 'GENERAL_SUCCESS') {
        if (searchProdPriceBook.data.data.length > 0) {
          setSearchProd(getSearchProd.concat(searchProdPriceBook.data.data))
          nameArray = searchProdPriceBook.data.data.map(names => {
            const category = names.productName
            const id = names.productID
            return {
              value: category,
              key: id,
              label: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <span
                    style={{
                      backgroundColor: 'lightcyan',
                      fontStyle: 'oblique',
                      fontWeight: 'bolder'
                    }}
                  >
                    <a>{category}</a>
                  </span>
                  <span>
                    <IntlMessages id='products.addeditpriceprod.searchresult' />
                  </span>
                </div>
              )
            }
          })
        }
        setOptions(nameArray)
      }

      if (searchProdPriceBook.data.msgCode == 'GENERAL_ERROR') {
        message.error(searchProdPriceBook.data.msgDescription)
      }
    } else {
      setOptions([])
      setSearchProd([])
    }
  }

  const onSelect = async selectedObj => {
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID = selectedObj.productID
      }
    } else {
      productID = ''
    }
    if (!StringIsNullOrEmpty(productID)) {
      // Here we call Details API
      await ds
        .getBookSearchProd(
          // `?keys=""&outletid=${getOutletID}&isstock=${true}&isInventory=${false}&isActiveProduct=${true}&productID=${productID}`
          `?keys=""&outletid=${getOutletID}&isstock=${false}&isInventory=${true}&isActiveProduct=${true}&isPB=${false}&isVariantProduct=${true}&productID=${productID}`
        )
        .then(response => {
          const productData = response.data
          if (productData.msgCode == 'GENERAL_SUCCESS') {
            if (productData && productData.data.length > 0) {
              newProd = productData.data.map((e, seq) => {
                return {
                  key: getRandomInt(100000000),
                  InventoryTakeItemID: '',
                  InventoryTakeID: '',
                  ProductID: e.productID,
                  OutletID: e.outletID,
                  ProductName: e.productName,
                  IsCounted: false,
                  Counted: '0',
                  Expected: e.currentInventory,
                  SKU: '',
                  Cost: e.supplyPrice,
                  IsChange: true
                }
              })
            } else {
              message.warning(
                `Can't add this product,because it is non track inventory product`
              )
            }
          }
          if (productData.msgCode == 'GENERAL_ERROR') {
            message.error(productData.msgDescription)
          }
        })
        .catch(e => console.log('Product Search Issue', e))

      if (newProd.length > 0) {
        if (
          getReduxInventoryProductData.length > 0 &&
          !getReduxInventoryProductData.some(
            e => getDecryptID(e.ProductID) === getDecryptID(productID)
          )
        ) {
          dispatch(
            loadInventoryTakesItemsData(
              getReduxInventoryProductData.concat(newProd)
            )
          )
        } else if (getReduxInventoryProductData.length == 0)
          dispatch(loadInventoryTakesItemsData(newProd))

        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
      } else {
        message.warning(
          `Can't add this product,because it is non track inventory product`
        )
      }
    }
  }
  // const onSelect = (value, option) => {
  //   let selectedOption =
  //     getSearchProd.filter((item) => item.productID == option.key).length > 0
  //       ? getSearchProd
  //           .filter((item) => item.productID == option.key)
  //           .map((e, seq) => {
  //             return {
  //               key: getRandomInt(100000000),
  //               InventoryTakeItemID: "",
  //               InventoryTakeID: "",
  //               ProductID: e.productID,
  //               OutletID: e.outletID,
  //               ProductName: e.productName,
  //               IsCounted: false,
  //               Counted: "0",
  //               Expected: e.currentInventory,
  //               SKU: "",
  //               Cost: e.supplyPrice,
  //               IsChange: true,
  //             };
  //           })
  //       : [];
  //   if (
  //     getReduxInventoryProductData.length > 0 &&
  //     !getReduxInventoryProductData.some(
  //       (e) => getDecryptID(e.ProductID) === getDecryptID(option.key)
  //     )
  //   ) {
  //     dispatch(
  //       loadInventoryTakesItemsData(
  //         getReduxInventoryProductData.concat(selectedOption)
  //       )
  //     );
  //   } else if (getReduxInventoryProductData.length == 0)
  //     dispatch(loadInventoryTakesItemsData(selectedOption));
  // };

  const redirectToListing = () => {
    history.push('/Dashboard/inventory/inventorycount/listing')
  }

  const rowSelection = {
    type: 'radio',
    onChange: (selectedRowKeys, selectedRows) => {
      setselectedRowKeys(selectedRowKeys)
      form.setFieldsValue({ ProductSearch: selectedRows[0].ProductName })
      //handleSearch(selectedRows[0].ProductName, selectedRows[0].OutletID);
      const productObj = {
        productID: selectedRows[0].ProductID
      }
      onSelect(productObj)
      setCurrentSelectedProduct(selectedRows[0])
      // console.log(
      //   `selectedRowKeys: ${selectedRowKeys}`,
      //   "selectedRows: ",
      //   selectedRows
      // );
    },
    getselectedRowKeys
  }
  const handleRowClick = record => {
    const selectedKey = record.key
    setselectedRowKeys([selectedKey])
    form.setFieldsValue({ ProductSearch: record.ProductName })
    const productObj = {
      productID: record.ProductID
    }
    onSelect(productObj)
    setCurrentSelectedProduct(record)
    focusAndScrollToInput()
  }

  const focusAndScrollToInput = () => {
    const inputNode = findDOMNode(inputRef.current)
    if (inputNode) {
      inputNode.focus()
      inputNode.scrollIntoView({ behavior: 'smooth', block: 'center' })
      inputNode.setSelectionRange(0, inputNode.value.length)
    }
  }

  // const  selectRow = (record) => {
  //   let selectedRowKeys = [];
  //   selectedRowKeys.push(record.key);
  //   setselectedRowKeys(selectedRowKeys);
  //   form.setFieldsValue({ ProductSearch: record.ProductName });
  //   handleSearch(record.ProductName);
  //   onSelect("", record.key);
  //   setCurrentSelectedProduct(record);
  //   setselectedRowKeys(selectedRowKeys);
  // }
  //#endregion Change Functions, OnClick Form Save

  const columnsProductInventoryItem = [
    {
      title: '',
      dataIndex: '',
      key: '',
      render (text, record) {
        if (record.Expected == record.Counted) {
          return <CheckOutlined />
        } else {
          return <StopOutlined />
        }
      }
    },
    {
      title: (
        <IntlMessages id='products.inventoryCount.inventorycountitemdetails.produt' />
      ),
      dataIndex: 'ProductName',
      key: 'ProductName'
    },
    {
      title: (
        <IntlMessages id='products.inventoryCount.inventorycountitemdetails.expected' />
      ),
      dataIndex: 'Expected',
      key: 'Expected'
    },
    {
      title: (
        <IntlMessages id='products.inventoryCount.inventorycountitemdetails.counted' />
      ),
      dataIndex: 'Counted',
      key: 'Counted'
    }
  ]
  return (
    <>
      {getIsAllowRead && isFeatureAllowed ? (
        <Spin
          tip={<IntlMessages id='sell.cashlisting.cashloading' />}
          spinning={getReduxInventoryProductDataLoading}
          size='large'
        >
          <div className='Content-wrapper inventory-Count'>
            <Row>
              <Col
                xl={16}
                lg={14}
                md={14}
                sm={24}
                xs={24}
                className='countedProd-wrapper'
              >
                <div className='back-arrow-h1'>
                  <h1 className='d-flex align-items-center'>
                    <ArrowLeftOutlined
                      className='dk-vertical-align'
                      onClick={redirectToListing}
                    />
                    <span className='mx-2'>
                      {' '}
                      {getReduxInventoryProductData &&
                      getReduxInventoryProductData != undefined &&
                      getReduxInventoryProductData[0] != undefined
                        ? getReduxInventoryProductData[0].InventoryName
                        : ''}
                    </span>
                  </h1>
                </div>

                <Row className='ant-row dk-row-bg-color m-0 Sec-heading-bg'>
                  <Col lg={12} md={24} sm={12} xs={24}>
                    <p className='title vd-hero-intro custom-font-color-black m-0'>
                      <IntlMessages id='products.inventoryCount.inventorycountitemdetails.countyourinventory' />
                    </p>
                  </Col>

                  <Col lg={12} md={24} sm={12} xs={24}>
                    <div className='pg-header-btn'>
                      <Button
                        className='custom-btn-cancel'
                        type='primary'
                        size='large'
                        onClick={() => handleInventoryPauseReview(false)}
                        disabled={getIsDisableUpdate}
                      >
                        <IntlMessages id='products.inventoryCount.inventorycountitemdetails.pause' />
                      </Button>
                      <Button
                        className='custom-btn-supplier'
                        form='ProductForm'
                        htmlType='submit'
                        type='primary'
                        size='large'
                        onClick={() => handleInventoryPauseReview(true)}
                        disabled={
                          getIsDisableUpdate
                            ? getIsDisableUpdate
                            : getReduxInventoryProductData.filter(
                                x => x.IsCounted == true
                              ).length > 0
                            ? false
                            : true
                        }
                      >
                        <IntlMessages id='products.inventoryCount.inventorycountitemdetails.review' />
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Card className='gx-card Filters-wrapper No-BoxShadow mt-4'>
                  <Form
                    {...formItemLayout}
                    form={form}
                    name={'SearchForm'}
                    className='ant-advanced-search-form product-search-form Filters-Form TaxReport-Filters'
                    layout='horizontal'
                    initialValues={{ Quantity: 1 }}
                  >
                    <>
                      <Row>
                        <Col xl={16} lg={24} md={24} sm={24} xs={24}>
                          <ProductSearch isLabel={true} />
                        </Col>

                        <Col
                          xl={5}
                          lg={8}
                          md={12}
                          sm={12}
                          xs={24}
                          className='quantity-input'
                        >
                          <InputGroup size='large' className=''>
                            <Form.Item
                              className='form-inner-pad-0'
                              name='Quantity'
                              label={
                                <IntlMessages id='products.inventoryCount.inventorycountitemdetails.quantity' />
                              }
                            >
                              <Input type='text' ref={inputRef} />
                            </Form.Item>
                          </InputGroup>
                        </Col>

                        <Col
                          xl={3}
                          lg={5}
                          md={12}
                          sm={12}
                          xs={24}
                          className='count-btn'
                        >
                          <Button
                            type='primary'
                            htmlType=''
                            className='dk-count-width'
                            disabled={
                              !isEmptyObject(getCurrentSelectedProduct)
                                ? false
                                : true
                            }
                            onClick={() => handleClickProductCount()}
                          >
                            <IntlMessages id='products.inventoryCount.inventorycountitemdetails.count' />
                          </Button>
                        </Col>

                        <Col xl={24} lg={11} md={24} sm={24} xs={24}>
                          <Form.Item
                            name='QuickScanMode'
                            valuePropName='checked'
                            className='ant-form-item-label-custom ant-form-margin-right Qsm'
                          >
                            <Checkbox defaultChecked={false}>
                              <IntlMessages id='products.inventoryCount.inventorycountitemdetails.quickscanmode' />
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  </Form>
                </Card>

                <Card className='tab-body-parent'>
                  <Tabs defaultActiveKey='1' size='large'>
                    <TabPane
                      tab={
                        <IntlMessages id='products.inventoryCount.inventorycountitemdetails.all' />
                      }
                      key='1'
                    >
                      <Card title=''>
                        {getReduxInventoryProductDataLoading ? (
                          <Skeleton count={7} height={35} />
                        ) : (
                          <CustomScrollbars className='gx-layout-sider-scrollbar'>
                            {/* <Table
                              className="gx-table-responsive"
                              columns={columnsProductInventoryItem}
                              dataSource={getReduxInventoryProductData}
                              pagination={false}
                              rowSelection={rowSelection}
                              rowClassName={(record) => getRowColor(record)}
                              // onRow={(record) => ({
                              //   onClick: () => {
                              //       selectRow(record);
                              //   },
                              // })}
                            /> */}

                            <Table
                              className='gx-table-responsive'
                              columns={columnsProductInventoryItem}
                              dataSource={getReduxInventoryProductData}
                              pagination={false}
                              rowClassName={record => getRowColor(record)}
                              onRow={record => ({
                                onClick: () => {
                                  handleRowClick(record)
                                }
                              })}
                            />
                          </CustomScrollbars>
                        )}
                      </Card>
                    </TabPane>
                    <TabPane
                      tab={
                        <IntlMessages id='products.inventoryCount.inventorycountitemdetails.counted' />
                      }
                      key='2'
                    >
                      <Card title=''>
                        {getReduxInventoryProductDataLoading ? (
                          <Skeleton count={7} height={35} />
                        ) : (
                          <CustomScrollbars className='gx-layout-sider-scrollbar'>
                            <Table
                              className='gx-table-responsive'
                              columns={columnsProductInventoryItem}
                              dataSource={getReduxInventoryProductData.filter(
                                x => x.IsCounted == true
                              )}
                              pagination={false}
                              onRow={record => ({
                                onClick: () => {
                                  handleRowClick(record)
                                }
                              })}
                            />
                          </CustomScrollbars>
                        )}
                      </Card>
                    </TabPane>
                    <TabPane
                      tab={
                        <IntlMessages id='products.inventoryCount.inventorycountitemdetails.uncounted' />
                      }
                      key='3'
                    >
                      <Card title=''>
                        {getReduxInventoryProductDataLoading ? (
                          <Skeleton count={7} height={35} />
                        ) : (
                          <CustomScrollbars className='gx-layout-sider-scrollbar'>
                            <Table
                              className='gx-table-responsive'
                              columns={columnsProductInventoryItem}
                              dataSource={getReduxInventoryProductData.filter(
                                x => x.IsCounted == false
                              )}
                              pagination={false}
                              onRow={record => ({
                                onClick: () => {
                                  handleRowClick(record)
                                }
                              })}
                            />
                          </CustomScrollbars>
                        )}
                      </Card>
                    </TabPane>
                  </Tabs>
                </Card>
              </Col>

              <Col
                xl={8}
                lg={10}
                md={10}
                sm={24}
                xs={24}
                className='counteditems-wrapper'
              >
                <ProductItemRightPanel />
              </Col>
            </Row>
          </div>
        </Spin>
      ) : (
        <NotAllowedComponent
          getAccessLoading={getAccessLoading}
          textType={!isFeatureAllowed ? 2 : 1}
        />
      )}
    </>
  )
}
export default InventoryCountItemDetails
